import React from "react";

import config from "config";
import DesktopContainerDrawer from "containers/DesktopContainerDrawer";
import MobileContainerDrawer from "containers/MobileContainerDrawer";
import useBusiness from "hooks/useBusiness";
import useFormatAddress from "hooks/useFormatAddress";
import useLocalize from "hooks/useLocalize";

import BusinessHeaderDesktop from "./BusinessHeaderDesktop";
import BusinessHeaderMobile from "./BusinessHeaderMobile";

interface Props {
	isReceiptMode?: boolean;
}

const BusinessHeader = ({ isReceiptMode }: Props) => {
	const { localize } = useLocalize();
	const { business } = useBusiness();
	const { formatAddressShort } = useFormatAddress();

	return (
		<>
			<DesktopContainerDrawer>
				<BusinessHeaderDesktop
					name={localize(business.localeNames, business.name)}
					logoUrl={business.logoUrl}
					categories={business.categories}
					address={business.address ? formatAddressShort(business.address) : ""}
					mapUrl={business.mapUrl}
					phoneNumber={business.phoneNumber}
					displayPhoneNumber={business.displayPhoneNumber}
					isReceiptMode={isReceiptMode}
					environment={config.environment}
				/>
			</DesktopContainerDrawer>
			<MobileContainerDrawer>
				<BusinessHeaderMobile
					name={localize(business.localeNames, business.name)}
					logoUrl={business.logoUrl}
					categories={business.categories}
					address={business.address ? formatAddressShort(business.address) : ""}
					mapUrl={business.mapUrl}
					phoneNumber={business.phoneNumber}
					displayPhoneNumber={business.displayPhoneNumber}
					isReceiptMode={isReceiptMode}
					environment={config.environment}
				/>
			</MobileContainerDrawer>
		</>
	);
};

export default BusinessHeader;
